import { Controller } from '@hotwired/stimulus'

// When selecting a country in a form, this controller will show the appropriate state/province input
export default class extends Controller {
    static targets = ['countrySelect', 'stateSelect', 'provinceSelect', 'otherStateInput']

    connect() {
        this.#updateStateFields()
    }

    countryValueChanged() {
        this.#updateStateFields()
    }

    #updateStateFields() {
        const country = this.countrySelectTarget?.value

        // Hide all fields first
        this.stateSelectTarget.classList.add('d-none')
        this.provinceSelectTarget.classList.add('d-none')
        this.otherStateInputTarget.classList.add('d-none')

        const usStateSelect = this.stateSelectTarget.querySelector('select, input')
        const caProvinceSelect = this.provinceSelectTarget.querySelector('select, input')
        const otherStateInput = this.otherStateInputTarget.querySelector('select, input')

        // Disable all inputs so they are ignored by server
        usStateSelect.disabled = true
        caProvinceSelect.disabled = true
        otherStateInput.disabled = true

        // Show and enable the appropriate field
        if (country === 'US') {
            this.stateSelectTarget.classList.remove('d-none')
            usStateSelect.disabled = false
        } else if (country === 'CA') {
            this.provinceSelectTarget.classList.remove('d-none')
            caProvinceSelect.disabled = false
        } else {
            this.otherStateInputTarget.classList.remove('d-none')
            otherStateInput.disabled = false
        }
    }
}
